module.exports = __webpack_public_path__ + "img/knu2_gallery11.a4c57e07.jpg";